import { createPersistedParamsStore } from "src/utils/createPersistedParamsStore";

const SORT_KEY = "sort";

const isManaged = (key: string): boolean =>
  key.startsWith("filter[") || key === SORT_KEY;

export const {
  usePersistedParams: useCasesPersistedParams,
  store: casesQueueParamsStore,
} = createPersistedParamsStore({
  storageKeyFn: (queueId) => `cases-queue-params/${queueId}`,
  isManaged,
});
